// components
import BottomNavigation from "../kits/bottomNavigation/BottomNavigation.jsx";

export default function FullScreenLayout(props) {
  return (
    <div className="">
      <div className="">
        <div />

        <div className={` `} style={{ height: "100vh" }}>
          {props.children}
        </div>
      </div>
    </div>
  );
}
